var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"alert alert-danger mt-4",attrs:{"id":"error_msg"},domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }